// extracted by mini-css-extract-plugin
export var table = "_x5-0";